module.exports = __webpack_public_path__ + "assets/img/user-avator.0ed7cfdc.png";